import React from 'react'
import { RouteObject, Navigate } from 'react-router-dom'

import { CustomerLoginGuard } from '@guards'
import { HomeLayout } from '@components/systems'

// home
import HomePage from '@pages/home/Home.page'

/* eslint-disable */
const HomeRoute = (mainUriList: { [id: string]: string }): RouteObject[] => {
	const res = [
		{
			path: '/',
			element: <HomeLayout />,
			children: [
				{
					path: '*',
					element: <Navigate to="/" replace={true} />,
				},
				{
					path: '/',
					element: <HomePage />,
				},
			],
		},
	]

	return res
}

export default HomeRoute
